import { EMPTY_STRING } from '@e-socna/empty';

import { ORGANIZATION_SEARCH_DIRECTOR_TYPE_PERSONNE_PHYSIQUE } from '../constants/organization-search-api.constant';
import type { OrganizationSearchDirector } from '../types/organization-search-result.type';

import { capitalizeName } from './capitalize-name.util';

export const formatDirectorName = (
  director: Readonly<OrganizationSearchDirector>,
): string =>
  director.type_dirigeant ===
  ORGANIZATION_SEARCH_DIRECTOR_TYPE_PERSONNE_PHYSIQUE
    ? [director.prenoms, director.nom]
        .filter((namePart): namePart is string => !!namePart)
        .map(capitalizeName)
        .join(' ')
    : capitalizeName(director.denomination ?? EMPTY_STRING);
